import config from 'config';
import { Link } from 'react-router-dom';
import { isGlobant, isHermandar } from 'utils/contants';
import styled from 'styled-components';
import Navbar from '../index.jsx';
import './header.scss';
import PremiumBtn from './PremiumBtn.jsx';

const Img = styled.img`
  width: ${(props) => props.width || '120px'};
`;

const Header = ({ user }) => {
  const premiumUser = user && user.role_name === 'user-read-only';

  return (
    <header>
      {!isGlobant && (
        <div className="header-custom bg-light d-flex align-items-center position-relative py-3 header-padding">
          <Link to="/">
            <Img
              src={config.logo}
              width={config.logo_width}
              className="d-inline-block align-top logo-reactour"
              alt="logo"
            />
          </Link>

          {isHermandar && user && <PremiumBtn premiumUser={premiumUser} />}
        </div>
      )}
      <Navbar user={user} />
    </header>
  );
};

export default Header;
